// extracted by mini-css-extract-plugin
export var csatScore = "_ly-5";
export var header = "_ly-1";
export var panelWrapper = "_ly-2";
export var postPreview = "_ly-3";
export var rightContent = "_ly-0";
export var wrappingText = "_ly-4";